let owner = null
let roots = []

const TABINDEX_STORE = 'data-tabindex-store'
const TABINDEX = 'tabindex'

export function trapFocus(nextOwner, nextRoots) {
  if (!nextOwner) {
    throw new Error('handling the omitted owner would create edge-cases @nskazki does not want to deal with')
  }

  owner = nextOwner
  roots = nextRoots

  const [interactive, uninteractive] = querySplit()

  for (const el of uninteractive) {
    negateTabIndex(el)
  }

  for (const el of interactive) {
    revertTabIndex(el)
  }
}

export function releaseFocus(maybeOwner) {
  if (owner !== maybeOwner) {
    return
  }

  owner = null

  for (const el of queryAll()) {
    revertTabIndex(el)
  }
}

function negateTabIndex(el) {
  if (el.getAttribute(TABINDEX)) {
    el.setAttribute(TABINDEX_STORE, el.getAttribute(TABINDEX))
  }

  el.setAttribute(TABINDEX, -1)
}

function revertTabIndex(el) {
  if (el.hasAttribute(TABINDEX_STORE)) {
    el.setAttribute(TABINDEX, el.getAttribute(TABINDEX_STORE))
    el.removeAttribute(TABINDEX_STORE)
  } else {
    el.removeAttribute(TABINDEX)
  }
}

function querySplit() {
  const interactive = []
  const uninteractive = []

  for (const el of queryAll()) {
    const isInteractive = roots.includes(el) || roots.some((root) => root.contains(el))

    if (isInteractive) {
      interactive.push(el)
    } else {
      uninteractive.push(el)
    }
  }

  return [interactive, uninteractive]
}

function queryAll() {
  return document.querySelectorAll('input,button,a,details')
}
